import { loginRequest, graphConfig } from "../config/msalConfig";
import { msalInstance } from "../index";

import apiConfig from "../config/api";

const backend_api = {
    apiStatus: async () => {
        const API_URL = `${apiConfig.backend[process.env.REACT_APP_API_ENV]}`;

        var fetchURL = `${API_URL}status`

        var api_response = ""

        await fetch(fetchURL, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
            }
        })
            .then(response => response.json())
            .then((result) => {
                console.log(result)
                api_response = result
            })
            .catch((error) => {
                console.log("Error", error);
                api_response = "There was an error"
            })

        return api_response;
    },
    addOrganisation: async (accessToken, tenantData, userData, sessionUID) => {
        if (!accessToken) {
            const account = msalInstance.getActiveAccount();
            if (!account) {
                throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
            }

            const response = await msalInstance.acquireTokenSilent({
                ...loginRequest,
                account: account
            });
            accessToken = response.accessToken;
        }

        const headers = new Headers();
        const bearer = `Bearer ${accessToken}`;

        const API_URL = `${apiConfig.backend[process.env.REACT_APP_API_ENV]}${process.env.REACT_APP_API_VER
            }`;

        var fetchURL = `${API_URL}/org/new-organisation`

        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const date = today.getDate();
        const currentDate = year + "-" + month + "-" + date;

        var api_body = JSON.stringify({
            "id": `details`,
            "tid": `${tenantData.tid}`,
            "tdn": `${tenantData.tdn}`,
            "jobTitle": `${userData.jobTitle}`,
            "mobilePhone": `${userData.mobilePhone}`,
            "session_id": `${sessionUID}`,
            "date": currentDate
        });

        var response = "API Complete"

        await fetch(fetchURL, {
            method: "POST",
            headers: {
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Authorization": bearer
            },
            body: api_body
        })
            .then(response => response.json())
            .then((result) => {
                console.log(result)
            })
            .catch((error) => {
                console.log("Error", error);
                response = "There was an error"
            })

        return response;
    },
    addQuestion: async (accessToken, tenantData, chatData) => {
        if (!accessToken) {
            const account = msalInstance.getActiveAccount();
            if (!account) {
                throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
            }

            const response = await msalInstance.acquireTokenSilent({
                ...loginRequest,
                account: account
            });
            accessToken = response.accessToken;
        }

        const headers = new Headers();
        const bearer = `Bearer ${accessToken}`;

        const API_URL = `${apiConfig.backend[process.env.REACT_APP_API_ENV]}${process.env.REACT_APP_API_VER
            }`;

        var fetchURL = `${API_URL}/ai/ask-question`

        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const date = today.getDate();
        const currentDate = year + "-" + month + "-" + date;

        var api_body = JSON.stringify({
            "tid": tenantData.tid,
            "oid": "",
            "date": currentDate,
            "session_id": chatData.session_id,
            "question_id": chatData.id,
            "model": chatData.modeld,
            "question": chatData.question,
            "response": chatData.response,
            "references": chatData.references,
            "sources": chatData.sources,
            "source_select": chatData.source_select,
            "latest": chatData.latest,
            "tone": chatData.tone
        });

        var response = "API Complete"

        await fetch(fetchURL, {
            method: "POST",
            headers: {
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Authorization": bearer
            },
            body: api_body
        })
            .then(response => response.json())
            .then((result) => {
                console.log(result)
            })
            .catch((error) => {
                console.log("Error", error);
                response = "There was an error"
            })

        return response;
    },
    updateChatState: async (accessToken, tenantData, chatData) => {
        if (!accessToken) {
            const account = msalInstance.getActiveAccount();
            if (!account) {
                throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
            }

            const response = await msalInstance.acquireTokenSilent({
                ...loginRequest,
                account: account
            });
            accessToken = response.accessToken;
        }

        const headers = new Headers();
        const bearer = `Bearer ${accessToken}`;

        const API_URL = `${apiConfig.backend[process.env.REACT_APP_API_ENV]}${process.env.REACT_APP_API_VER
            }`;

        var fetchURL = `${API_URL}/ai/update-chat-state`

        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const date = today.getDate();
        const currentDate = year + "-" + month + "-" + date;

        var api_body = JSON.stringify({
            "tid": tenantData.tid,
            "oid": "",
            "date": currentDate,
            "id": chatData.session_id,
            "rag_question_state": chatData.rag_question_state,
        });

        var response = "API Complete"

        await fetch(fetchURL, {
            method: "POST",
            headers: {
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Authorization": bearer
            },
            body: api_body
        })
            .then(response => response.json())
            .then((result) => {
                console.log(result)
            })
            .catch((error) => {
                console.log("Error", error);
                response = "There was an error"
            })

        return response;
    },
    updateFeedback: async (accessToken, tenantData, chatData, quick_feedback, summary_feedback, long_feedback) => {
        if (!accessToken) {
            const account = msalInstance.getActiveAccount();
            if (!account) {
                throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
            }

            const response = await msalInstance.acquireTokenSilent({
                ...loginRequest,
                account: account
            });
            accessToken = response.accessToken;
        }

        const headers = new Headers();
        const bearer = `Bearer ${accessToken}`;

        const API_URL = `${apiConfig.backend[process.env.REACT_APP_API_ENV]}${process.env.REACT_APP_API_VER
            }`;

        var fetchURL = `${API_URL}/ai/update-feedback`

        var api_body = JSON.stringify({
            "tid": tenantData.tid,
            "oid": "",
            "id": chatData.session_id,
            "question_id": chatData.id,
            "long_feedback": long_feedback,
            "summary_feedback": summary_feedback,
            "quick_feedback": quick_feedback,
        });

        var response = "API Complete"

        await fetch(fetchURL, {
            method: "POST",
            headers: {
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Authorization": bearer
            },
            body: api_body
        })
            .then(response => response.json())
            .then((result) => {
                console.log(result)
            })
            .catch((error) => {
                console.log("Error", error);
                response = "There was an error"
            })

        return response;
    },
    addResponse: async (accessToken, tenantData, chatData, aiResponse, sources, input_tokens, output_tokens, total_tokens) => {
        if (!accessToken) {
            const account = msalInstance.getActiveAccount();
            if (!account) {
                throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
            }

            const response = await msalInstance.acquireTokenSilent({
                ...loginRequest,
                account: account
            });
            accessToken = response.accessToken;
        }

        const headers = new Headers();
        const bearer = `Bearer ${accessToken}`;

        const API_URL = `${apiConfig.backend[process.env.REACT_APP_API_ENV]}${process.env.REACT_APP_API_VER
            }`;

        var fetchURL = `${API_URL}/ai/update-response`

        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const date = today.getDate();
        const currentDate = date + "-" + month + "-" + year;

        console.log("Response api data ", chatData)

        var api_body = JSON.stringify({
            "tid": tenantData.tid,
            "oid": "",
            "date": currentDate,
            "session_id": chatData.session_id,
            "question_id": chatData.id,
            "model": chatData.model,
            "question": chatData.question,
            "response": aiResponse,
            "references": chatData.references,
            "sources": sources,
            "latest": chatData.latest,
            "tone": chatData.tone
        });

        var response = "API Complete"

        await fetch(fetchURL, {
            method: "POST",
            headers: {
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Authorization": bearer
            },
            body: api_body
        })
            .then(response => response.json())
            .then((result) => {
                console.log(result)
            })
            .catch((error) => {
                console.log("Error", error);
                response = "There was an error"
            })

        return response;
    },
    deleteFile: async (accessToken, tenantData, session_id) => {
        if (!accessToken) {
            const account = msalInstance.getActiveAccount();
            if (!account) {
                throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
            }

            const response = await msalInstance.acquireTokenSilent({
                ...loginRequest,
                account: account
            });
            accessToken = response.accessToken;
        }

        const headers = new Headers();
        const bearer = `Bearer ${accessToken}`;

        const API_URL = `${apiConfig.backend[process.env.REACT_APP_API_ENV]}${process.env.REACT_APP_API_VER
            }`;

        var fetchURL = `${API_URL}/ai/delete-file`

        var api_body = JSON.stringify({
            "tid": tenantData.tid,
            "session_id": session_id,
        });

        var response = "API Complete"

        await fetch(fetchURL, {
            method: "POST",
            headers: {
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Authorization": bearer
            },
            body: api_body
        })
            .then(response => response.json())
            .then((result) => {
                console.log(result)
            })
            .catch((error) => {
                console.log("Error", error);
                response = "There was an error"
            })

        return response;
    },
    getProfile: async (accessToken, tenantData) => {
        if (!accessToken) {
            const account = msalInstance.getActiveAccount();
            if (!account) {
                throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
            }

            const response = await msalInstance.acquireTokenSilent({
                ...loginRequest,
                account: account
            });
            accessToken = response.accessToken;
        }

        const bearer = `Bearer ${accessToken}`;

        const API_URL = `${apiConfig.backend[process.env.REACT_APP_API_ENV]}${process.env.REACT_APP_API_VER
            }`;

        var fetchURL = `${API_URL}/profile/get-profile?tid=${tenantData.tid}`

        console.log(fetchURL)
        var api_response = ""

        await fetch(fetchURL, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Authorization": bearer
            }
        })
            .then(response => response.json())
            .then((result) => {
                api_response = result
                console.log("Get Profile ", result)
            })
            .catch((error) => {
                console.log("Error", error);
                api_response = "There was an error"
            })

        return api_response;
    },
    updateProfile: async (accessToken, tenantData, userData) => {
        if (!accessToken) {
            const account = msalInstance.getActiveAccount();
            if (!account) {
                throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
            }

            const response = await msalInstance.acquireTokenSilent({
                ...loginRequest,
                account: account
            });
            accessToken = response.accessToken;
        }

        const headers = new Headers();
        const bearer = `Bearer ${accessToken}`;

        const API_URL = `${apiConfig.backend[process.env.REACT_APP_API_ENV]}${process.env.REACT_APP_API_VER
            }`;

        var fetchURL = `${API_URL}/profile/update-settings`

        console.log("SADSAD ", userData)

        var api_body = JSON.stringify({
            "id": `details`,
            "tid": `${tenantData.tid}`,
            "tdn": `${tenantData.tdn}`,
            "general": {
                "show_startup": userData.general.show_startup,
            },
            "profile_settings": {
                "system_color": `${userData.profile_settings.system_color}`,
                "dark_mode": userData.profile_settings.dark_mode,
                "bold_text": userData.profile_settings.bold_text,
                "ui_size": userData.profile_settings.ui_size,
                "message_width": userData.profile_settings.message_width
            },
            "ai_settings": {
                "model": `${userData.ai_settings.model}`,
                "tone": `${userData.ai_settings.tone}`,
            }
        });

        var response = "API Complete"

        await fetch(fetchURL, {
            method: "POST",
            headers: {
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Authorization": bearer
            },
            body: api_body
        })
            .then(response => response.json())
            .then((result) => {
                console.log(result)
            })
            .catch((error) => {
                console.log("Error", error);
                response = "There was an error"
            })

        return response;
    },
    getHistory: async (accessToken, tenantData) => {
        if (!accessToken) {
            const account = msalInstance.getActiveAccount();
            if (!account) {
                throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
            }

            const response = await msalInstance.acquireTokenSilent({
                ...loginRequest,
                account: account
            });
            accessToken = response.accessToken;
        }

        const bearer = `Bearer ${accessToken}`;

        const API_URL = `${apiConfig.backend[process.env.REACT_APP_API_ENV]}${process.env.REACT_APP_API_VER
            }`;

        var fetchURL = `${API_URL}/profile/get-history?tid=${tenantData.tid}`

        console.log(fetchURL)
        var api_response = ""

        await fetch(fetchURL, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Authorization": bearer
            }
        })
            .then(response => response.json())
            .then((result) => {
                api_response = result
                console.log("Get Profile ", result)
            })
            .catch((error) => {
                console.log("Error", error);
                api_response = "There was an error"
            })

        return api_response;
    }
};

export default backend_api